module.exports = __webpack_public_path__ + "img/like.abf3dd3e.png";